export const siteSettings = {
  name: "Pulse Markets Pro",
  link: "https://pulsemarketspro.com",
  email: "support@pulsemarketspro.com",
  appLink: "https://app.pulsemarketspro.com",
};
